import { E_INVOICE_APP } from '../constants/eInvoicePermissions';

export function hasPermission(permissions, appCode, permissionCode) {
  return (permissions?.[appCode] ?? []).includes(permissionCode);
}

export function hasEInvoicePermission(permissions, permissionCode) {
  return hasPermission(permissions, E_INVOICE_APP, permissionCode);
}
